import { Product } from '../models';

export const MOCK_PRODUCTS: Product[] = [
  {
    id: 'prod_BTgmUZKYOisQXS',
    stripe_id: 'prod_BTgmUZKYOisQXS',
    level_name: 'BASIC',
    name: 'Draw Basic',
    plans: [
      {
        id: 'basic_year',
        stripe_id: 'basic_year',
        interval: 'year',
        interval_count: 1,
        amount: 12000,
        product_id: 'prod_BTgmUZKYOisQXS',
        active: true,
      },
      {
        id: 'basic_month',
        stripe_id: 'basic_month',
        interval: 'month',
        interval_count: 1,
        amount: 1500,
        product_id: 'prod_BTkNl1zKOkvB5V',
        active: true,
      },
    ],
  },
  {
    id: 'prod_BUDCj9GPmCiEYA',
    stripe_id: 'prod_BUDCj9GPmCiEYA',
    level_name: 'PROFESSIONAL',
    name: 'Draw Pro',
    plans: [
      {
        id: 'pro_year',
        stripe_id: 'pro_year',
        interval: 'year',
        interval_count: 1,
        amount: 36000,
        product_id: 'prod_BUDCj9GPmCiEYA',
        active: true,
      },
      {
        id: 'pro_month',
        stripe_id: 'pro_month',
        interval: 'month',
        interval_count: 1,
        amount: 3500,
        product_id: 'prod_BUZjs2JTVRKscq',
        active: true,
      },
    ],
  },
  {
    id: 'prod_IkDtmhTGUZts7M',
    stripe_id: 'prod_IkDtmhTGUZts7M',
    level_name: 'ESSENTIAL',
    name: 'Essential',
    plans: [
      {
        id: 'price_1I8jRhAjvybNGG91GH3bEI0N',
        stripe_id: 'price_1I8jRhAjvybNGG91GH3bEI0N',
        interval: 'month',
        interval_count: 1,
        amount: 6000,
        product_id: 'prod_IkDtmhTGUZts7M',
        active: true,
      },
      {
        id: 'price_1I8jTeAjvybNGG918pcVzemu',
        stripe_id: 'price_1I8jTeAjvybNGG918pcVzemu',
        interval: 'year',
        interval_count: 1,
        amount: 66000,
        product_id: 'prod_IkDvYW2UI6Ddk0',
        active: true,
      },
    ],
  },
  {
    id: 'prod_BTTwpEtlZQNrHR',
    stripe_id: 'prod_BTTwpEtlZQNrHR',
    level_name: 'PREMIUM',
    name: 'Advanced',
    plans: [
      {
        id: 'price_1Im9YoAjvybNGG91OxzHsysa',
        stripe_id: 'price_1Im9YoAjvybNGG91OxzHsysa',
        interval: 'month',
        interval_count: 1,
        amount: 11900,
        product_id: 'prod_BTTwpEtlZQNrHR',
        active: true,
      },
      {
        id: 'price_1IE8SvAjvybNGG91HsJZv76X',
        stripe_id: 'price_1IE8SvAjvybNGG91HsJZv76X',
        interval: 'month',
        interval_count: 1,
        amount: 10500,
        product_id: 'prod_BTTwpEtlZQNrHR',
        active: false,
      },
      {
        id: 'premium_month',
        stripe_id: 'premium_month',
        interval: 'month',
        interval_count: 1,
        amount: 7000,
        product_id: 'prod_BTTwpEtlZQNrHR',
        active: false,
      },
      {
        id: 'price_1Im9ZmAjvybNGG91nwXsUzup',
        stripe_id: 'price_1Im9ZmAjvybNGG91nwXsUzup',
        interval: 'year',
        interval_count: 1,
        amount: 126000,
        product_id: 'prod_BTcB1EzlrOAfVj',
        active: true,
      },
      {
        id: 'price_1IE8V0AjvybNGG9184pFlyaG',
        stripe_id: 'price_1IE8V0AjvybNGG9184pFlyaG',
        interval: 'year',
        interval_count: 1,
        amount: 114000,
        product_id: 'prod_BTcB1EzlrOAfVj',
        active: false,
      },
      {
        id: 'premium_year',
        stripe_id: 'premium_year',
        interval: 'year',
        interval_count: 1,
        amount: 72000,
        product_id: 'prod_BTcB1EzlrOAfVj',
        active: false,
      },
    ],
  },
  {
    id: 'prod_QA7k1ZIvV8PDOg',
    stripe_id: 'prod_QA7k1ZIvV8PDOg',
    level_name: 'TAKEOFF_BASIC',
    name: 'Takeoff Basic',
    plans: [
      {
        id: 'price_1PJnVXAjvybNGG91brGWOsNG',
        stripe_id: 'price_1PJnVXAjvybNGG91brGWOsNG',
        interval: 'month',
        interval_count: 1,
        amount: 12000,
        product_id: 'prod_QA7k1ZIvV8PDOg',
        active: true,
      },
      {
        id: 'price_1PJnWvAjvybNGG91S5f8ycWd',
        stripe_id: 'price_1PJnWvAjvybNGG91S5f8ycWd',
        interval: 'year',
        interval_count: 1,
        amount: 118800,
        product_id: 'prod_QA7mHtcqKTxZEx',
        active: true,
      },
    ],
  },
  {
    id: 'prod_BTfGWeQq2Ml1B5',
    stripe_id: 'prod_BTfGWeQq2Ml1B5',
    level_name: 'PREMIUM_PLUS',
    name: 'Estimate Pro',
    plans: [
      {
        id: 'price_1PJoBhAjvybNGG91HpSpeBS7',
        stripe_id: 'price_1PJoBhAjvybNGG91HpSpeBS7',
        interval: 'year',
        interval_count: 1,
        amount: 154800,
        product_id: 'prod_BTfGWeQq2Ml1B5',
        active: true,
      },
      {
        id: 'price_1Im9XZAjvybNGG91nQ2TIE0u',
        stripe_id: 'price_1Im9XZAjvybNGG91nQ2TIE0u',
        interval: 'year',
        interval_count: 1,
        amount: 142800,
        product_id: 'prod_BTfGWeQq2Ml1B5',
        active: false,
      },
      {
        id: 'price_1IE8cAAjvybNGG91UoA3YLXe',
        stripe_id: 'price_1IE8cAAjvybNGG91UoA3YLXe',
        interval: 'year',
        interval_count: 1,
        amount: 126000,
        product_id: 'prod_BTfGWeQq2Ml1B5',
        active: false,
      },
      {
        id: 'price_1I9WduAjvybNGG91Vs9GQfRE',
        stripe_id: 'price_1I9WduAjvybNGG91Vs9GQfRE',
        interval: 'year',
        interval_count: 1,
        amount: 150000,
        product_id: 'prod_BTfGWeQq2Ml1B5',
        active: false,
      },
      {
        id: 'premium_plus_year',
        stripe_id: 'premium_plus_year',
        interval: 'year',
        interval_count: 1,
        amount: 108000,
        product_id: 'prod_BTfGWeQq2Ml1B5',
        active: false,
      },
      {
        id: 'price_1PJoAeAjvybNGG91t88HqiPv',
        stripe_id: 'price_1PJoAeAjvybNGG91t88HqiPv',
        interval: 'month',
        interval_count: 1,
        amount: 16000,
        product_id: 'prod_BTvhL9ijWbjygF',
        active: true,
      },
      {
        id: 'price_1Im9WZAjvybNGG91QM9m398y',
        stripe_id: 'price_1Im9WZAjvybNGG91QM9m398y',
        interval: 'month',
        interval_count: 1,
        amount: 14900,
        product_id: 'prod_BTvhL9ijWbjygF',
        active: false,
      },
      {
        id: 'price_1IE8ZyAjvybNGG91OHUxoinn',
        stripe_id: 'price_1IE8ZyAjvybNGG91OHUxoinn',
        interval: 'month',
        interval_count: 1,
        amount: 11900,
        product_id: 'prod_BTvhL9ijWbjygF',
        active: false,
      },
      {
        id: 'price_1I79xKAjvybNGG91dAE64G27',
        stripe_id: 'price_1I79xKAjvybNGG91dAE64G27',
        interval: 'month',
        interval_count: 1,
        amount: 12000,
        product_id: 'prod_BTvhL9ijWbjygF',
        active: false,
      },
      {
        id: 'premium_plus_month',
        stripe_id: 'premium_plus_month',
        interval: 'month',
        interval_count: 1,
        amount: 10500,
        product_id: 'prod_BTvhL9ijWbjygF',
        active: false,
      },
    ],
  },
];
